import {
    BackgroundEvents,
    EventsManager,
    WinEvents,
} from "../../../abstracts/events/EventsManager";
import { AbstractModuleController } from "../../../abstracts/modules/AbstractModuleController";
import { ShakeProps } from "../../../abstracts/types/interfaces";
import { shake } from "../../../abstracts/utils/GraphicUtils";
import { DDD } from "../../DDD";
import { DDDBackgroundView } from "./DDDBackgroundView";

export class DDDBackgroundController extends AbstractModuleController {
    protected handleEvents() {
        super.handleEvents();

        EventsManager.on(BackgroundEvents.SHOW_NEXT_BACKGROUND, () => {
            this.view.showNextBackground(DDD.model.data.nextMode);
        });

        EventsManager.on(WinEvents.SHAKE_NORMAL_SCREEN, (shakeProps: ShakeProps) => {
            shake({
                displayObject: this.view,
                intensity: shakeProps.intensity,
                defaultX: shakeProps.defaultX ? shakeProps.defaultX : 0,
                defaultY: shakeProps.defaultY ? shakeProps.defaultY : 0,
                duration: shakeProps.duration ? shakeProps.duration : 0.1,
                repeat: shakeProps.repeat ? shakeProps.repeat : 1,
            });
        });

        EventsManager.trigger(BackgroundEvents.GET_BACKGROUND_VIEW, this.view);
    }

    public get name(): string {
        return `DDDBackgroundController`;
    }

    public get view(): DDDBackgroundView {
        if (this._view === undefined || this._view === null) {
            this._view = new DDDBackgroundView();
        }
        return this._view as DDDBackgroundView;
    }
}
